import Rule from "../../../../common/rule";
import DriveService from "../../../../../services/drive-service";
import FootballState from "../../../state/football-state";

export default class CreateDrive extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        // Drives are now opened eagerly by FootballService._startDriveWithoutPlay
        // (no synthetic Start of Drive play is created), so this rule is dormant
        // for new games — it only fires on a legacy StartDrive fragment, which
        // never occurs in the implicit-drive flow.
        return fragment.associatedState === FootballState.StartDrive;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const drive = await DriveService.startDrive(gameContext);

        gameContext.currentDriveId = drive.id;
        gameContext.setDriveContext({
            ...gameContext.driveContext,
            triggerDrive: false,
            driveTeamId: gameContext.getPossessionTeamId()
        });

        this.kickoffContextChanges(gameContext);

        play.driveId = drive.id;
    }

    kickoffContextChanges(gameContext) {
        /* This function is used to trigger a PAT for Kickoff plays ending in a touchdown */
        const lastWasTd =
            (gameContext.isVisitorPossession() &&
                gameContext.fieldPosition <= 0) ||
            (gameContext.isHomePossession() &&
                gameContext.fieldPosition >= gameContext.getFieldLength());
        if (lastWasTd) gameContext.triggerPAT = true;
    }
}
